import StratVirtualGuitar from "./StratVirtualGuitar";
export default function App() {
  return <StratVirtualGuitar />;
}
